import { Box, Checkbox, Typography } from "@mui/material";
import React from "react";

const IncludeVendorToggle = ({
  includeVendorColumn,
  toggleIncludeVendorColumn,
}) => {
  const handleToggle = () => {
    toggleIncludeVendorColumn(!includeVendorColumn);
  };


  return (
    <Box>
      <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <Checkbox
          sx={{ marginLeft: -3 }}
          checked={includeVendorColumn}
          onChange={handleToggle}
        />
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: 700, marginRight: 1 }}
        >
         Include Vendor Column
        </Typography>
      </Box>
    </Box>
  );
};

export default IncludeVendorToggle;
